import { useEffect } from 'react';

/**
 * Hook para rastreamento de sessão.
 * Com autenticação via Keycloak (sem Supabase Auth), o tracking via register_user_session
 * não é usado - o RPC depende de auth.uid() do Supabase.
 * Mantido vazio para compatibilidade; analytics de sessão podem ser implementados via Keycloak/backend.
 */
export const useSessionTracking = () => {
  useEffect(() => {
    // No-op: sessões agora são gerenciadas apenas pelo Keycloak
  }, []);
};
